import { useSectionObserver } from 'hooks/use-section-observer'
import { ArticleContent } from 'components/container'
import { Layout } from 'components/layout'
import { GlobalStyleLight } from 'styles/global-light'
import { PageHeader } from 'components/page-header'
import { PageNav } from 'components/page-nav'
import { Intro } from './sections/intro'
import { War } from './sections/war'
import { Shamanism } from './sections/shamanism'
import { Horses } from './sections/horses'
import { Musicians } from './sections/musicians'
import { Bonesetters } from './sections/bonesetters'
import { Theme } from './styled'
import HeaderImg from './assets/Buryatia.webp'

export const Buryatiya = () => {
  const { addItem } = useSectionObserver()

  return (
    <Layout invertedHeader>
      <GlobalStyleLight />
      <Theme />
      <PageNav />

      <PageHeader title="Буряты" imageRatio="1920 / 963" imageUrl={HeaderImg} />

      <ArticleContent>
        <Intro />
        <War ref={addItem} />
        <Shamanism ref={addItem} />
        <Horses ref={addItem} />
        <Musicians ref={addItem} />
        <Bonesetters ref={addItem} />
      </ArticleContent>
    </Layout>
  )
}
